import { render, staticRenderFns } from "./BlCertificate.vue?vue&type=template&id=788f845c&scoped=true"
import script from "./BlCertificate.vue?vue&type=script&lang=js"
export * from "./BlCertificate.vue?vue&type=script&lang=js"
import style0 from "./BlCertificate.vue?vue&type=style&index=0&id=788f845c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f845c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788f845c')) {
      api.createRecord('788f845c', component.options)
    } else {
      api.reload('788f845c', component.options)
    }
    module.hot.accept("./BlCertificate.vue?vue&type=template&id=788f845c&scoped=true", function () {
      api.rerender('788f845c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/BlCertificate.vue"
export default component.exports